<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XMKi98/images/9781612437392.jpg?1689138691309" alt="This image is the cover for the book Why Do Roller Coasters Make You Puke?, Fascinating Bathroom Readers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Why Do Roller Coasters Make You Puke?, Fascinating Bathroom Readers
      </h1>
      <p class="bookDescription body article font2">
        <b>A fun and fascinating trivia book with a wide range of intriguing questions and entertainingly written answers from a bestselling author.</b><br/><br/>Perfect for trivia junkies everywhere, this new collection will surprise readers with fascinating answers to age-old curiosities, such as:<br/><br/><b>• Does a goldfish’s memory really only last a few seconds?</b><br/><br/><b>• Do plants feel pain?</b><br/><br/><b>• Why do cats’ eyes glow in the dark?</b><br/><br/><b>• Why do people seem more attractive when we’re drunk?</b><br/><br/><b>• Why didn’t people smile in old photos?</b><br/><br/>Each page offers another witty response to the questions of our time. From men’s fashion to the meaning of life, from the educational to the entertaining, this book has something for everyone.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew Thompson
      </h2>
      
      <p class="authorDescription body article">Andrew Thompson practices law but his obsession with finding out the truth about aspects of the world that we take for granted has led him to accumulate a vast body of knowledge which he has distilled into book form. Andrew has written five bestselling trivia books, 'Why Skies are Blue andParrots Talk', 'Why Do Kamikaze Pilots Wear Helmets?', 'What Did We UseBefore Toilet Paper?', 'Can Holding in a Fart Kill You?' and 'Hair ofthe Dog to Paint the Town Red', as well as the novel 'The HemingwaySolution', the travel memoir 'Dog Days', and a book about misused words'The Suppository of all Wisdom'.Read more about Andrew and his books at andrewthompsonwriter.co.uk</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Ulysses Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2d4d3fe0